import React from 'react';
import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../atomic/text/Text';
import style from '../../IndividualTacticStyle.module.css';

export const CandlePatternTacticPanelHeader = () => {
  return (
    <thead>
      <tr>
        <th className={style.fieldHeader}>
          <Body3 fontWeight={700} color={colors.lightGrey}>
            #
          </Body3>
        </th>
        <th className={style.fieldHeader}>
          <Body3 fontWeight={700} color={colors.lightGrey}>
            Pattern
          </Body3>
        </th>
        <th className={style.fieldHeader}>
          <Body3 fontWeight={700} color={colors.lightGrey}>
            Add/Remove
          </Body3>
        </th>
      </tr>
    </thead>
  );
};
